import React from 'react';
import { observer } from 'mobx-react';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { FormFieldInput } from '../../../../../global/form/form-field-input/form-field-input';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import Text from '../../../../../global/text/text';
import { EnablementStatus } from '../../../../../../constants/common.constants';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { PodiumAccessType } from '../../../../../../api/podium.dao';
import OECheckbox from '../../../../../global/oe-checkbox/oe-checkbox';
import TemplatePodiumFormVM from './template-podium-form.viewmodel';
import {
    getPodiumAccess,
    PARTICIPANTS_TAB_LABEL_TEXT,
    PODIUM_ACCESS_TYPE_TEXT,
    PODIUM_ATTENDEES_INFO_MESSAGE,
    PODIUM_ATTENDEES_LABEL,
    PODIUM_CHAT_LABEL,
    PODIUM_ENABLE_TEXT,
    PODIUM_FEATURES_TEXT,
    PODIUM_PARTICIPANTS_INFO_MESSAGE,
    PODIUM_PARTICIPANTS_LABEL,
    PODIUM_QUESTION_ANSWER_LABEL,
    PRESENTER_VIEW_ENABLE_TEXT
} from '../../../../../_events/_manage-event/_connections/_meeting-connections-form/podium-form/podium-form.texts';
import { InfoPopover } from '../../../../../global/info-popover/info-popover';
import { FormattedMessage } from 'react-intl';

export type PodiumFormPresentationProps = {
    vm: TemplatePodiumFormVM;
};

export const TemplatePodiumFormPresentation = observer(({ vm }: PodiumFormPresentationProps): JSX.Element => {
    const intl = vm.formVM.getIntl;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form oe-form--podium'>
                    <div className='oe-form__body'>
                        <FormFieldInput.Toggle
                            toggle={vm.togglePodiumEnabled}
                            isSelected={vm.podiumLinkEnabled}
                            text={<Text
                                {...PODIUM_ENABLE_TEXT}
                                values={{
                                    suffix: vm.podiumLinkEnabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED
                                }}
                            />}
                            className='meeting-toggle'
                        />
                        {
                            vm.podiumLinkEnabled &&
                            <>
                                <FormFieldInput.Toggle
                                    toggle={vm.togglePresenterViewEnabled}
                                    isSelected={vm.podiumPresenterViewEnabled}
                                    text={<Text
                                        {...PRESENTER_VIEW_ENABLE_TEXT}
                                        values={{
                                            suffix: vm.podiumPresenterViewEnabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED
                                        }}
                                    />}
                                    className='meeting-toggle'
                                />
                                <FormField label={intl.formatMessage(PODIUM_ACCESS_TYPE_TEXT)} >
                                    <select
                                        className='oe-form-field__control'
                                        value={vm.podiumAccessType}
                                        onChange={e => vm.setAccessType(e.target.value as PodiumAccessType)}
                                    >
                                        {getPodiumAccess(intl).map(({ value, label }, i) => {
                                            return <option value={value} key={value + i}>{label}</option>;
                                        })
                                        }
                                    </select>
                                </FormField>
                                <div className='podium-features-section'>
                                    <div className='podium-features-section__title'>{intl.formatMessage(PODIUM_FEATURES_TEXT)}</div>
                                    <div className='podium-features-section__list'>
                                        <div className='podium-features-section__item--with-info'>
                                            <OECheckbox
                                                checked={vm.podiumParticipantsEnabled}
                                                onChange={() => vm.checkParticipantsFeature()}
                                                label={intl.formatMessage(PODIUM_PARTICIPANTS_LABEL)}
                                                classNames='oe-form-field__checkbox checkbox-filter__checkbox'
                                            />
                                            <InfoPopover>
                                                <div><FormattedMessage {...PODIUM_PARTICIPANTS_INFO_MESSAGE} /></div>
                                            </InfoPopover>
                                        </div>
                                        {vm.podiumParticipantsEnabled && <FormField label={intl.formatMessage(PARTICIPANTS_TAB_LABEL_TEXT)}>
                                            <input
                                                className='oe-form-field__control'
                                                value={vm.podiumParticipantsLabel}
                                                onChange={e => vm.setParticipantsLabel(e.target.value)}
                                                onBlur={vm.setParticipantsLabelTouched}
                                            />
                                            {vm.participantsLabelTouched && vm.participantsLabelErrorMessage &&
                                                <span className='oe-form-field__error'>
                                                    {vm.participantsLabelErrorMessage}
                                                </span>
                                            }
                                        </FormField>}
                                        <div className='podium-features-section__item--with-info'>
                                            <OECheckbox
                                                checked={vm.podiumAttendeesEnabled}
                                                onChange={() => vm.checkAttendeesFeature()}
                                                label={intl.formatMessage(PODIUM_ATTENDEES_LABEL)}
                                                classNames='oe-form-field__checkbox checkbox-filter__checkbox'
                                            />
                                            <InfoPopover>
                                                <div><FormattedMessage {...PODIUM_ATTENDEES_INFO_MESSAGE} /></div>
                                            </InfoPopover>
                                        </div>
                                        <OECheckbox
                                            checked={vm.podiumQuestionAnswerEnabled}
                                            onChange={() => vm.checkQuestionAnswerFeature()}
                                            label={intl.formatMessage(PODIUM_QUESTION_ANSWER_LABEL)}
                                            classNames='oe-form-field__checkbox checkbox-filter__checkbox'
                                        />
                                        <OECheckbox
                                            checked={vm.podiumChatEnabled}
                                            onChange={() => vm.checkChatFeature()}
                                            label={intl.formatMessage(PODIUM_CHAT_LABEL)}
                                            classNames='oe-form-field__checkbox checkbox-filter__checkbox'
                                        />
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right' >
                    <DefaultCloseSubWindowButton
                        text={applyText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={() => vm.updatePodiumDetails()}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div >
            }
        />
    );
});